import { useMemo } from 'react';
import { getCountries, getCountryCallingCode } from 'react-phone-number-input';
import ko from 'react-phone-number-input/locale/ko.json';
import en from 'react-phone-number-input/locale/en.json';
import zh from 'react-phone-number-input/locale/zh.json';
import ja from 'react-phone-number-input/locale/ja.json';
import es from 'react-phone-number-input/locale/es.json';
import { useLanguage } from '../contexts/LanguageContext';

/* react-phone-number-input 라이브러리가 제공하는 국가명 locale 매핑.
   key 는 BE 언어코드 (LanguageContext.BE_LANG_MAP 와 일치). */
const LOCALES_BY_BE = { ko, en, zh, ja, es };

function buildOptions(localeMap, sortLocale) {
  return getCountries()
    .map((code) => ({ value: code, label: localeMap[code] || code }))
    .filter((o) => o.label)
    .sort((a, b) => a.label.localeCompare(b.label, sortLocale));
}

/* React hook — 현재 사이트 언어에 맞춘 국가 옵션 반환. AccountEdit/MyAccount 에서 사용. */
export function useCountryOptions() {
  const { beLang } = useLanguage();
  return useMemo(
    () => buildOptions(LOCALES_BY_BE[beLang] || ko, beLang),
    [beLang]
  );
}

export { getCountryCallingCode };
